import React from "react";
import PropTypes from "prop-types";
import Switch from "react-switch";
import { useTranslation } from "react-i18next";
import { ReactComponent as Edit2Icon } from "images/profile/edit-icon.svg";
import useEditNewMember from "../hooks/useEditNewMember";
import EditNewMemberModal from "../agencyTeamModal/upsertNewMemberModal";
import useAgencyState from "../hooks/useAgencyState";

function AgencyTeamCardHeader({
  userDetails,
  userDomains = [],
  userSubDomains = [],
  user = {},
  updateUsersResult = () => {},
  filterQuery = {},
  isEditShowEditOnHover = false,
}) {
  const userRates = userDetails?.userRates ?? [];
  const userServices = userDetails?.userServices ?? [];
  const [t] = useTranslation();
  const { isOpen, setIsOpen, onSubmit, isLoading, onHandleDefaultValues } =
    useEditNewMember({ user, filterQuery, updateUsersResult });
  const { onHandleUserActivity } = useAgencyState({
    userId: user.id,
  });

  return (
    <>
      {isOpen && (
        <EditNewMemberModal
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          onSubmit={onSubmit}
          isLoading={isLoading}
          title={t("editNewMember")}
          isEditModal={true}
          userRates={userRates}
          userServices={userServices}
          userDomains={userDomains}
          userSubDomains={userSubDomains}
          defaultValues={onHandleDefaultValues()}
        />
      )}

      <div className="grid  grid-cols-card-grid-header gap-[12px]  w-full self-stretch">
        <Switch
          checked={user?.isActive}
          onChange={(checked) => {
            const callback = (isSuccess) => {
              if (isSuccess) {
                updateUsersResult((prevState) => {
                  const currentUsers = prevState?.results ?? [];
                  const updateUser = currentUsers.map((el) => {
                    if (el.id === user.id) {
                      return { ...el, isActive: checked };
                    }
                    return el;
                  });

                  return { ...prevState, results: updateUser };
                });
              }
            };
            onHandleUserActivity(checked, callback);
          }}
          onColor="#023A66"
          handleDiameter={16}
          uncheckedIcon={false}
          checkedIcon={false}
          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
          height={20}
          width={40}
          className="react-switch"
        />

        <div className="flex flex-col flex-1">
          <div className="text-base-black font-bold text-[18px] leading-normal">
            {`${user?.firstName ?? ""} ${user?.lastName ?? ""}`}
          </div>
          <div className="text-gray-500 font-medium text-[16px] leading-normal">
            {user?.email ?? ""}
          </div>
        </div>

        <Edit2Icon
          className={`cursor-pointer ${
            isEditShowEditOnHover ? "visible" : "invisible"
          }`}
          onClick={() => setIsOpen(true)}
        />
      </div>
    </>
  );
}

AgencyTeamCardHeader.propTypes = {
  userDetails: PropTypes.object,
};

export default AgencyTeamCardHeader;
